import { ProjectsData } from './ProjectsData'
import styles from './ProjectsSubhead.module.scss'
import { Flex } from '../common/flex/Flex'

const title: string = 'Types of Innovation Projects'

const ProjectsSubhead = () => {
  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <div className={styles.imageContainer} />
        <div className={styles.titleWrapper}>
          <h2 className={styles.title} color="#fff">
            {title}
          </h2>
        </div>
      </div>
      <Flex gap={48} wrap="wrap" className={styles.contentContainer}>
        {ProjectsData.map(project => {
          return (
            <Flex gap={24} className={styles.cardContainer} key={project.title}>
              <div className={styles.projectImageContainer}>
                <img src={project.img} alt="" />
              </div>
              <Flex gap={16} direction="column" className={styles.textWrapper}>
                <div className={styles.titleContainer}>
                  <p className={styles.projectTitle}>{project.title}</p>
                </div>
                <div className={styles.textContainer}>
                  <p className={styles.cardText}>{project.description}</p>
                </div>
              </Flex>
            </Flex>
          )
        })}
        <div className={styles.dots1} />
        <div className={styles.dots2} />
        <div className={styles.dots3} />
      </Flex>
    </div>
  )
}

export default ProjectsSubhead
